<template>
  <div class="hulinPage">
    <van-loading size="24px" v-if="loadShow" vertical>加载中...</van-loading>
    <div v-if="!loadShow">
      <van-cell-group class="forestInput">
        <van-field
          :label="$t('forestProtectList.theme') + '：'"
          :disabled="!editType"
          v-model="baseData.title"
          :placeholder="$t('forestProtectList.themeNameTip')"
          clearable
          required
        />
      </van-cell-group>
      <van-cell-group class="forestInput">
        <van-field
          :label="$t('forestProtectList.hlTime') + '：'"
          v-model="baseData.patrolTime"
          :placeholder="$t('common.select')"
          :is-link="editType"
          @click="checkTimeShow"
          required
          readonly
        />
      </van-cell-group>
      <van-cell-group class="forestInput">
        <van-field
          :label="$t('forestProtectList.participants') + '：'"
          v-model="roleValueList"
          :placeholder="$t('common.select')"
          :is-link="editType"
          @click="checkRolePicker"
          required
          readonly
        />
      </van-cell-group>
      <van-cell-group class="forestInput">
        <van-field
          :label="$t('forestProtectList.location') + '：'"
          v-model="baseData.regionName"
          :placeholder="$t('common.select')"
          :is-link="editType"
          required
          readonly
          @click="getPosition"
        />
      </van-cell-group>
      <van-cell-group class="forestInput moreText">
        <p>{{ $t("forestProtectList.findQuestionTit") }}</p>
        <van-field
          v-model="baseData.problemRemarks"
          :disabled="!editType"
          :placeholder="$t('common.contentTip')"
          clearable
          required
        />
      </van-cell-group>
      <van-cell-group class="forestInput moreText">
        <p>{{ $t("forestProtectList.hulinText") }}</p>
        <van-field
          v-model="baseData.workRemarks"
          :disabled="!editType"
          :placeholder="$t('common.contentTip')"
          clearable
          required
        />
      </van-cell-group>
      <van-cell-group class="forestInput">
        <van-field
          :label="$t('forestProtectList.noteTaker') + '：'"
          v-model="creator"
          readonly
        />
      </van-cell-group>

      <!-- 弹出框 -->
      <!-- 时间选择器 -->
      <van-popup v-model="timePickerShow" position="bottom">
        <van-datetime-picker
          v-model="currentDate"
          type="datetime"
          :title="$t('forestProtectList.xzForexzstPatrolTime')"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="onCancel"
          @confirm="onSaveTime"
        />
      </van-popup>
      <!-- 位置选择 -->
      <van-popup
        v-model="selectPositionPicker"
        position="bottom"
        class="showBox"
      >
        <select-position
          @setPosition="savePosition"
          :params="positionData"
          :selecRightType="selecRightType"
          :selecLeftType="selecLeftType"
        ></select-position>
      </van-popup>
      <!-- 选择人员 -->
      <van-popup v-model="selectHlyPicker" position="bottom" class="showBox">
        <select-hly
          @getRoleData="changeRoleData"
          :selecRightType="selecRightType"
          :selecLeftType="selecLeftType"
        ></select-hly>
      </van-popup>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { mapState } from "vuex";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { dateFormat, dateTimeFormat } from "@/utils/common";
const selectPosition = () => import("@/views/hulin/selectPosition");
const selectHly = () => import("@/views/hulin/selectHly");
export default {
  name: "hulin",
  data() {
    return {
      loadShow: true,
      editType: false,
      addType: true,
      edtiId: "",
      creatTime: "",
      baseData: {
        title: "",
        patrolTime: "",
        participants: [],
        problemRemarks: "",
        regionCode: "",
        workRemarks: "",
        regionName: "",
        locationPoint: {},
      },
      creator: "", //创建者
      roleValueList: "",
      selectHlyPicker: false,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(),
      timePickerShow: false, //时间弹窗
      selectPositionPicker: false, //位置选择
      positionData: {}, //传递的位置信息
      selecRightType: "",
      selecLeftType: "",

      clientType: getDeviceType(),
    };
  },
  components: {
    selectPosition,
    selectHly,
  },
  mounted() {
    window.onRightClicked = this.checkMain; //保存/新增通知
    window.onLeftClicked = this.cancelText; //取消富文本编辑
    window.setUserPoint = this.setUserPoint;
    this.edtiId =
      this.$route.query.commonId == "" ? "" : this.$route.query.commonId;

    this.$nextTick(() => {
      this.initPage();
      this.getAppPoint();
    });
  },
  methods: {
    initPage() {
      if (this.userinfo) {
        if (this.edtiId == "" || this.edtiId == undefined) {
          this.loadShow = false;
          this.creator = this.userinfo.realName;
          this.editType = true;
          this.initAndroid();
          document.title = "创建护林单";
          return;
        } else {
          this.getPageMain();
        }
      }
    },
    initAndroid() {
      if (this.clientType == "android") {
        window.android.getInfo(111, this.$t("common.commit"));
      }
    },
    getPageMain() {
      let _this = this;
      _this.$api.hulin
        .hylDetails(this.edtiId)
        .then((res) => {
          if (res.code == "1") {
            this.loadShow = false;
            console.log(res.data);
            _this.roleValueList = res.data.userNames;
            _this.creatTime = res.data.patrolTime;
            _this.baseData = Object.assign({}, _this.baseData, res.data);

            _this.creator = res.data.creatorName;

            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            if (month < 10) {
              month = "0" + month;
            }
            let newTime = year + "-" + month;
            // _this.editType = true;

            if (
              _this.userinfo.uid == res.data.creator &&
              newTime == res.data.yearMonth
            ) {
              document.title = "修改护林单";
              _this.initAndroid();
              _this.baseData.id = _this.edtiId;
              _this.editType = true;
            } else {
              document.title = "护林单详情";
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //时间选择
    checkTimeShow() {
      if (this.editType) {
        this.timePickerShow = true;
      }
    },
    onSaveTime(data) {
      this.baseData.patrolTime = dateTimeFormat(data);
      this.timePickerShow = false;
    },
    onCancel() {
      this.timePickerShow = false;
    },
    //护林员选择
    checkRolePicker() {
      let _this = this;
      if (_this.editType) {
        _this.selectHlyPicker = true;
        if (_this.clientType == "android") {
          window.android.getInfo(111, _this.$t("common.save"));
          window.android.getInfo(112, _this.$t("common.cancel"));
        } else {
          //IOS
          window.webkit.messageHandlers.closeNavigation.postMessage("1");
        }
      }
    },
    changeRoleData(data) {
      //选择人员回调
      console.log(data);
      let _this = this;
      _this.roleValueList = data.count;
      if (data.ids) {
        _this.baseData.participants = data.ids;
      }
      _this.selectHlyPicker = false;
      if (_this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.commit"));
        window.android.getInfo(112, "");
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("2");
      }
      _this.selecRightType = "";
      _this.selecLeftType = "";
    },
    //位置选择
    getPosition() {
      let _this = this;
      if (_this.editType) {
        _this.selectPositionPicker = true;
        if (this.clientType == "android") {
          window.android.getInfo(111, _this.$t("common.ok"));
          window.android.getInfo(112, _this.$t("common.goBack"));
        } else {
          //IOS
          window.webkit.messageHandlers.closeNavigation.postMessage("1");
        }
      }
    },
    getAppPoint() {
      //获取用户当前的位置
      if (this.clientType == "android") {
        window.android.getInfo(117);
      } else {
        window.webkit.messageHandlers.getUserPoint.postMessage({
          callBack: "setUserPoint", //回调 必传
        });
      }
    },
    setUserPoint(data) {
      if (this.clientType == "android") {
        console.log(data);
        let cord = data.split(" ");
        console.log(JSON.stringify(cord));
        if (cord.length == 2) {
          this.positionData.lon = cord[0]; //经度
          this.positionData.lat = cord[1]; //纬度
          this.baseData.locationPoint = cord[0] + "," + cord[1];
          // this.baseData.locationPoint= cord[1];
        }
      } else {
        let dataObj = JSON.parse(data);
        this.positionData.lon = dataObj.lon; //经度
        this.positionData.lat = dataObj.lat; //纬度
        this.baseData.locationPoint =  dataObj.lon+ "," + dataObj.lat;
        // this.baseData.locationPoint.y = dataObj.lat;
      }
    },
    savePosition(data) {
      //选择位置回调
      let _this = this;
      _this.selectPositionPicker = false;
      if (data != "") {
        _this.getAddress(data);
      }
      if (this.clientType == "android") {
        window.android.getInfo(111, _this.$t("common.commit"));
        window.android.getInfo(112, "");
      } else {
        //IOS
        window.webkit.messageHandlers.closeNavigation.postMessage("2");
      }
      _this.selecRightType = "";
      _this.selecLeftType = "";
    },
    getAddress(data) {
      let _this = this;
      let point = {
        objid: "",
        type: "",
        x: data[0],
        y: data[1],
        z: 0,
      };

      _this.$api.hulin
        .currentInfo(point)
        .then((res) => {
          if (res.code == "1") {
            this.baseData.regionCode = res.data.zqInfo.zqCode;
            this.baseData.regionName =
              res.data.zqInfo.shiName +
              res.data.zqInfo.xianName +
              res.data.zqInfo.xiangName +
              res.data.zqInfo.cunName;
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    checkMain(changeType) {
      this.selecRightType = changeType;
      console.log(changeType);
      if (changeType == this.$t("common.commit") || this.clientType == "IOS") {
        if (
          this.baseData.participants == "" ||
          this.baseData.problemRemarks == "" ||
          this.baseData.regionName == "" ||
          this.baseData.title == "" ||
          this.baseData.workRemarks == ""
        ) {
          this.$toast(this.$t("common.ggToastTip"));
        } else {
          this.saveMain();
        }
      }
    },
    saveMain() {
      let _this = this;
      //编辑/新增
      if (this.addType) {
        this.addType = false;
        _this.$api.hulin
          .addAndUpdate(_this.baseData)
          .then((res) => {
            if (res.code == "1") {
              _this.$toast(_this.$t("common.issueTip"));
              setTimeout(function () {
                //将当前页面关闭
                if (_this.clientType == "android") {
                  //安卓
                  window.android.getInfo(106, "2");
                } else {
                  //IOS
                  window.webkit.messageHandlers.closePage.postMessage("2");
                }
              }, 3000);
            } else {
              _this.addType = true;
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            _this.addType = true;
            console.log(err);
          });
      } else {
        this.$toast(this.$t("common.moreClickToastMsg"));
      }
    },
    cancelText(changeLeftType) {
      this.selecLeftType = changeLeftType;
    },
  },
  computed: {
    ...mapState(["userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        this.initPage();
        // if (this.edtiId == "" || this.edtiId == undefined) {
        //   this.creator = this.userinfo.realName;
        //   this.editType = true;
        // }else{
        //    this.getPageMain();
        // }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.hulinPage {
  width: 100%;
  height: 100%;
  padding-top: 10px;
  background-color: #f6f6f6;
  .forestInput {
    margin: 10px 0;
    .van-cell {
      .van-cell__title {
        span {
          display: inline-block;
          width: 110px;
          font-size: 14px;
          font-family: "PingFangSC-Regular", "PingFang SC";
          font-weight: 400;
          color: #666;
          line-height: 22px;
        }
      }
      .van-cell__value {
        .van-field__control {
          text-align: right;
          font-size: 14px;
          color: #333;
        }
      }
    }
  }
  .forestInput.moreText {
    padding-top: 13px;
    p {
      font-size: 14px;
      font-family: "PingFangSC-Regular", "PingFang SC";
      font-weight: 400;
      color: #333;
      line-height: 22px;
      padding: 0 16px;
    }
    .van-cell {
      .van-cell__value {
        .van-field__control {
          text-align: left;
          font-size: 14px;
        }
      }
    }
    .van-cell.van-cell--required::before {
      top: -20px;
    }
  }
  .forestInput:first-child {
    margin-top: 0;
  }
  .showBox.van-popup {
    width: 100%;
    height: 100%;
  }
}
</style>